export default "__VITE_ASSET__DFUu5459__"